import { ApiEpBillingProductFeatureSubscription } from "./feature_subscription";
import { ApiEpBillingProductPlanProduct } from "./plan_product";
import { ApiEpBillingProductPostsPackage } from "./posts_package";
import { ApiEpBillingTokenPackage } from "./token";
export class ApiEpBillingProduct {
}
ApiEpBillingProduct.FeatureSubscription = ApiEpBillingProductFeatureSubscription;
ApiEpBillingProduct.PlanProduct = ApiEpBillingProductPlanProduct;
ApiEpBillingProduct.PostsPackage = ApiEpBillingProductPostsPackage;
ApiEpBillingProduct.TokenPackage = ApiEpBillingTokenPackage;
//# sourceMappingURL=product.js.map